<template>
  <v-btn color="primary lighten-2"
         small
         icon
         :disabled="requestState === 'Loading'"
         :loading="requestState === 'Loading'"
         @click="handleClickExport">
    <v-icon small>fas fa-file-download</v-icon>
  </v-btn>
</template>

<script>
  import FileSaver from 'file-saver'
  import {RequestState} from '../../../requestState'
  import {invoiceService, notificationService} from '../../../application'
  import {extractFileName} from '../../../helpers/file'

  export default {
    name: 'export-invoice-as-csv',
    props: {
      invoiceId: {
        type: Number,
        required: true,
      }
    },
    data() {
      return {
        requestState: RequestState.NotPerformed
      }
    },
    methods: {
      handleClickExport() {
        if (this.requestState === RequestState.Loading) {
          return
        }

        this.requestState = RequestState.Loading;
        invoiceService
          .exportInvoiceToCsv({
            invoiceId: this.invoiceId
          })
          .then(data => {
            const csv = '\ufeff' + data.data;
            const fileName = extractFileName(data);
            let blob = new Blob([csv], {type: 'text/csv;charset=UTF-8;'});
            FileSaver.saveAs(blob, fileName);
            this.requestState = RequestState.Success;
          })
          .catch(e => {
            notificationService.error('Can\'t perform operation');
            this.requestState = RequestState.Failed;
          })
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/analytics/invoices/ExportInvoiceAsCsv.vue